import { useEffect } from "react";

const COMPACT_LIST_CLASS = "compact-list";

export const updateClassList = (mode: string) => {
  document.documentElement.classList.remove("light", "dark");
  if (mode === "auto") {
    if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.add("light");
    }
  } else if (mode === "light" || mode === "dark") {
    document.documentElement.classList.add(mode);
  }
};

export const updateListDensityClass = (mode: string) => {
  document.documentElement.classList.remove(COMPACT_LIST_CLASS);
  if (mode === "compact") {
    document.documentElement.classList.add(COMPACT_LIST_CLASS);
  }
};

const useAddDarkModeToHtmlElement = () => {
  useEffect(() => {
    updateClassList(window.localStorage.getItem("dark-mode") || "auto");
    updateListDensityClass(window.localStorage.getItem("list-density") || "default");
  }, []);
};

export default useAddDarkModeToHtmlElement;
